import angular from 'angular';
import wageAdvanceModalComponent from './wageAdvanceModal.component';

let wageAdvanceModalModule = angular.module('wageAdvanceModal', [
])

.component('wageAdvanceModal', wageAdvanceModalComponent)

.name;

export default wageAdvanceModalModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvanceModal/wageAdvanceModal.js